export default "__VITE_ASSET__ce7af7b5__"